<!--
 * @Version      : V1.0
 * @Date         : 2025-06-09 16:40:50
 * @fileName     :
 * @Description  : 合同归档详情
-->
<template>
  <el-drawer :title="title" v-loading="loading" :visible.sync="dialogDrawer" direction="rtl" :wrapperClosable="false"
    size="80%" :before-close="closeDrawer">
    <div class="details px-20 py-20 border-box">
      <el-row :gutter="20">
        <el-col :span="24">
          <descriptions v-if="!showDesc" :span="6" :status="status" :row-data="rowData" :rules="rules"
            :columns="columns" ref="descriptionsRef">
            <template #contractReceivePaymentSlot="{ data }">
              <div class="flex items-center">
                <div>
                  <!--收款合同 -->
                  <el-select clearable v-model="contractReceivePaymentId" :disabled="data.disabled" filterable remote
                    reserve-keyword placeholder="请选择收款合同"
                    :remote-method="(e) => remoteMethod(e, 'contractReceivePaymentId')" :loading="selectLoading"
                    @change="(e) => selectChange(e)">
                    <el-option v-for="item in receivableContractOption" :key="item.id" :label="item.contractName"
                      @click.native="curOption(item, data, 'contractReceivePaymentId')" :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <el-button type="text" @click="openViewProject(contractReceivePaymentId, '2')"
                  v-if="contractReceivePaymentId">查看</el-button>
              </div>
            </template>
          </descriptions>
        </el-col>
      </el-row>
    </div>
    <div class="details-footer px-20 py-20 border-box" v-if="status !== 'view'">
      <el-button type="primary" @click="submit()">提交</el-button>
      <el-button @click="clearForm()" v-if="status == 'add' || status == 'edit'">清空</el-button>
    </div>
    <view-other-details ref="viewProjectRef"></view-other-details>
  </el-drawer>
</template>

<script>
import descriptions from '@/components/descriptions/index.vue'
import { addContractReceivePaymentFilingApi, editContractReceivePaymentFilingApi, queryContractReceivePaymentFilingDetailsApi, queryListJsonForFillingApi } from '@/api/contractFiling/index'
import { queryBasicOwnersListApi } from '@/api/basicInfo/index'
import { queryPageForLedgerListApi } from '@/api/receivableContract‌/index'
import { getContractInvoiceAndReceivedDataApi } from '@/api/paymentContract/index'
import { auditProcessStatus } from '@/utils/index'
import { dataPage } from "@/api/sys/dictData";
import viewOtherDetails from "@/components/viewOtherDetails/index.vue"
export default {
  components: {
    descriptions,
    viewOtherDetails
  },
  props: {
    title: {
      type: String,
      default: '开票详情'
    },
    status: {
      type: String,
      default: 'view'
    }
  },
  data() {
    return {
      defaultAvatar: 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png',
      dialogDrawer: false,
      contractReceivePaymentId: "",
      selectLoading: false,
      loading: false,
      customerForm: {},
      showDesc: false,
      columns: [
        { key: 'contractReceivePaymentId', label: '关联合同', span: 6, placeholder: '请选择关联合同', disabled: true, defaultValue: '', slotName: 'contractReceivePaymentSlot' },
        {
          key: 'relatedItemsReceivePayment', height: 'auto', label: '关联项收款情况', span: 6, placeholder: '', disabled: true, input: 'table', isShowAdd: false,
          columns: [
            { label: '总金额(元)', key: 'totalAmount', width: '120px', align: 'center', placeholder: '请输入阶段', input: 'input', required: true, defaultValue: "" },
            { label: '已开票金额(元)', key: 'invoicedAmount', width: '120px', placeholder: '请输入预计金额', align: 'center', input: 'input', defaultValue: "" },
            { label: '未开票金额(元)', key: 'noInvoicedAmount', width: '120px', placeholder: '请输入预计日期', align: 'center', input: 'date', defaultValue: "" },
            { label: '已收款金额(元)', key: 'receivedAmount', width: '120px', align: 'center', placeholder: '请输入备注', input: 'input', defaultValue: "" },
            { label: '未收款金额(元)', key: 'noReceivedAmount', width: '120px', align: 'center', placeholder: '请输入备注', input: 'input', defaultValue: "" },
          ],
          defaultValue: []
        },
        { key: 'contractReceivePaymentElectronic', height: '450px', label: '收款合同电子版', span: 6, placeholder: '请上传收款合同电子版', uploadType: 'project', input: 'upload', fileMaxSize: 20, disabled: true, defaultValue: [], accept: '.xls,.xlsx,.pdf,.doc,.docx,.txt,.bmp,.jpg,.jpeg,.png,.tif,.gif,.svg,.webp,.zip,.rar,.7z', limit: 50, },
        { key: 'businessActivationForm', height: '450px', label: '业务开通单', span: 6, placeholder: '请上传业务开通单', uploadType: 'project', input: 'upload', fileMaxSize: 20, disabled: true, defaultValue: [], accept: '.xls,.xlsx,.pdf,.doc,.docx,.txt,.bmp,.jpg,.jpeg,.png,.tif,.gif,.svg,.webp,.zip,.rar,.7z', limit: 50, },

        { key: 'notes', label: '备注', span: 6, placeholder: '请输入备注', input: 'textarea', type: 'textarea', disabled: true, defaultValue: '' },
      ],
      rowData: {},
      cloneColumns: [],//复制一遍
      rules: {
        // notes: [
        //   { required: true, message: '请输入备注', trigger: 'blur' },
        // ],
        contractReceivePaymentElectronic: [],
        ipAndAccountPassword: [
          { required: true, message: '请输入IP地址/账号密码', trigger: 'blur' },
        ],
        caBroadbandNumber: [
          { required: true, message: '请输入CA/宽带号', trigger: 'blur' },
        ],

      },
      processList: [],
      receivableContractOption: []
    }
  },
  mounted() {
    this.dictOption('invoice_type');
    this.getOwnersList();
    this.getLedgerContractList();
    this.cloneColumns = JSON.parse(JSON.stringify(this.columns))

  },
  methods: {
    auditProcessStatus,
    //核心方法 判断是否是新增 还是编辑
    async openDrawer(row) {
      this.dialogDrawer = true;
      this.$nextTick(() => {
        switch (this.status) {
          case 'view':
            this.queryDetails({ id: row.id })
            break;
          case 'add':
            //新增把原有的数据设置默认值
            this.showDesc = true;
            if (this.columns[4].key == 'caBroadbandNumber' && this.columns[5].key == 'ipAndAccountPassword') {
              this.columns.splice(4, 2);
            }
            for (let i = 0; i < this.columns.length; i++) {
              this.columns[i].disabled = false;
              this.columns[i].defaultValue = this.cloneColumns[i].defaultValue;
            }
            this.$nextTick(() => {
              this.showDesc = false;
            })
            this.reverseDisplayList({}, 'contractReceivePaymentId')
            break;
          case 'edit':
            this.queryDetails({ id: row.id })
            break;
          case 'change':
            this.queryDetails({ id: row.id })
            break;
          default:
            break;
        }
      })
    },
    //关闭弹框
    closeDrawer() {
      this.dialogDrawer = false;
      this.contractReceivePaymentId = "";
    },
    //详情查询
    queryDetails(params) {
      this.loading = true;
      this.showDesc = true;
      queryContractReceivePaymentFilingDetailsApi(params).then(res => {
        this.loading = false;
        this.showDesc = false;
        if (res.code == 200) {
          this.rowData = res.data;
          if (res.data.projectTypeCode == '3') { //只有在互联网服务类型才显示
            this.columns.splice(4, 0,
              { key: 'caBroadbandNumber', label: 'CA/宽带号', span: 6, placeholder: '请输入CA/宽带号', input: 'input', type: 'text', disabled: true, defaultValue: '' },
              { key: 'ipAndAccountPassword', label: 'IP地址/账号密码', span: 6, placeholder: '请输入IP地址/账号密码', input: 'input', type: 'text', disabled: true, defaultValue: '' },
            )
          }
          if (this.status !== 'add') {
            this.contractReceivePaymentId = res.data.contractReceivePaymentId;
            for (let i = 0; i < this.columns.length; i++) {
              this.columns[i].disabled = this.status == 'view' ? true : false;
              if (this.columns[i].key == 'relatedItemsReceivePayment') {
                this.reverseDisplayList({ id: res.data.contractReceivePaymentId }, 'contractReceivePaymentId')
              } else {
                this.columns[i].defaultValue = this.rowData[this.columns[i].key];
              }

            }
          }
        }
      }).catch(err => {
        this.loading = false;
      })
    },
    //提交
    submit(status = 1) {
      this.$refs.descriptionsRef.submit().then((formData = {}) => {
        if ('relatedItemsReceivePayment' in formData) {
          delete formData.relatedItemsReceivePayment
        }
        let params = {
          ...formData,
          contractReceivePaymentId: this.contractReceivePaymentId,
        }
        this.loading = true;
        if (this.status == 'add') {
          addContractReceivePaymentFilingApi(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
            this.loading = false;
            this.closeDrawer();
            this.queryData();
          }).catch(err => {
            this.loading = false;
          })
        } else {
          editContractReceivePaymentFilingApi(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            }
            this.loading = false;
            this.closeDrawer();
            this.queryData();
          }).catch(err => {
            this.loading = false;
          })
        }

      })
    },
    //暂存
    temporarilyStore() {
      this.submit(0);
    },
    //清空描述组件form
    clearForm() {
      this.$refs.descriptionsRef.resetForm()
    },
    //查询列表
    queryData() {
      this.$emit('initQueryData')
    },
    async dictOption(type) {
      let params = {
        query: {
          dictType: type
        }
      }
      dataPage(params).then(res => {
        if (res.code == 200) {
          this.columns.map(item => {
            if (item.key == 'invoiceTypeCode' && type == 'invoice_type') {
              item.option = res.data.rows || []
            }
            return item
          })
        }
      })
    },
    //开票单位
    getOwnersList() {
      let params = {
        unitName: ""
      }
      queryBasicOwnersListApi(params).then(res => {
        if (res.code == 200) {
          this.columns.map(item => {
            if (item.key == 'invoiceOwnerUnitId') {
              item.option = res.data || []
            }
            return item
          })
        }
      })
    },
    //查询收款合同台账
    getLedgerContractList(v = '') {
      let params = {
        params:{
          contractName:v
        }
      }
      this.selectLoading = true;
      queryListJsonForFillingApi(params).then(res => {
        this.selectLoading = false;
        if (res.code == 200) {
          this.receivableContractOption = res.data;
        }
      })
    },
    // 通过合同-获取开票和收款数据
    getInvoiceAndReceivedDataContract(id) {
      let params = {
        id,
      }
      getContractInvoiceAndReceivedDataApi(params).then(res => {
        if (res.code == 200) {
          this.columns.map(item => {
            if (item.key == 'relatedItemsReceivePayment') {
              item.defaultValue = res.data ? [res.data] : [] || []
            }
            return item
          })
        }
      })
    },
    remoteMethod(query, current = '') {
      if (query !== '') {
        switch (current) {
          case 'contractReceivePaymentId':
            this.getLedgerContractList(query)
            break;
          default:
            break;
        }
      } else {
        this.projectOptions = [];
        this.receivableContractOption = [];
      }
    },
    selectChange(e) {
      if (!e && this.columns[4].key == 'caBroadbandNumber' && this.columns[5].key == 'ipAndAccountPassword') {
        this.columns.splice(4, 2);
      }
    },
    //下拉当前选中
    curOption(v = {}, slotData, current) {
      let item = v;
      if (this.status == 'add' || this.status == 'edit' || this.status == 'change') {
        if (item.projectTypeCode == '3') { //只有在互联网服务类型才显示
          this.columns.splice(4, 0,
            { key: 'caBroadbandNumber', label: 'CA/宽带号', span: 6, placeholder: '请输入CA/宽带号', input: 'input', type: 'text', disabled: true, defaultValue: '' },
            { key: 'ipAndAccountPassword', label: 'IP地址/账号密码', span: 6, placeholder: '请输入IP地址/账号密码', input: 'input', type: 'text', disabled: true, defaultValue: '' },
          )
        }
        for (let i = 0; i < this.columns.length; i++) {
          for (let key in item) {
            if (this.columns[i].key == key && !this.columns[i].slotName) {
              this.columns[i].disabled = false;
              // if(this.columns[i].key == 'receivePaymentPlanList'){
              //   console.log(item,'v')
              //   this.columns[i].defaultValue = item.makePaymentPlanList || [];
              // }
            }
          }
        }
      }
      this.reverseDisplayList(v, current)
    },
    //关联收款情况反显
    reverseDisplayList(data = {}, current) {

      if (current) {
        if (current == 'contractReceivePaymentId' && data.hasOwnProperty('id')) {
          this.getInvoiceAndReceivedDataContract(data.id)
        } else {
          this.columns.map(item => {
            if (item.key == 'relatedItemsReceivePayment') {
              item.defaultValue = [
                {
                  totalAmount: '--',
                  noInvoicedAmount: '--',
                  noReceivedAmount: '--',
                  receivedAmount: '--',
                  invoicedAmount: '--'
                }
              ]
            }
            return item
          })
        }
      }
    },
    openViewProject(id, correlationType) {
      this.$refs.viewProjectRef.viewProject(id, correlationType)
    }
  }
}
</script>

<style scoped lang="scss">
.details-footer {
  height: 50px;
  line-height: 50px;
  text-align: right;
}

.progress-box{
  padding: 5px;
  box-sizing: border-box;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  border-radius: 5px;
  margin-bottom: 5px;
  background: #285af1;
  .progress-title {
    font-size: 18px;
    padding-bottom: 10px;
    color: #fff;
  }
  .progress-desc-info {
    padding: 10px 0px 10px 0px;

    .items {
      font-size: 15px;
      display: inline-block;
      vertical-align: middle; 
    }
  }
}
.approval-progress {
  .progress-title {
    font-size: 18px;
    padding-bottom: 10px;
  }

  .progress-con {
    .progress-desc {
      line-height: 20px;
      color: #303133;

      .progress-time {
        margin-left: 10px;
        color: #909399;
      }

      .notes-text {
        display: -webkit-box;
        /* 设置为弹性盒子模型 */
        -webkit-box-orient: vertical;
        /* 垂直排列 */
        -webkit-line-clamp: 2;
        /* 显示最多 3 行 */
        overflow: hidden;
        /* 隐藏超出的部分 */
        text-overflow: ellipsis;
        /* 使用省略号 */
      }
    }
  }
}

::v-deep .el-drawer__header {
  color: #000;
  font-size: 18px;
}

::v-deep .el-breadcrumb__separator {
  color: #fff;
}
</style>
